import React from 'react';
import { ReactComponent as ShoppingIcon } from '../../assets/bag.svg';
import './cart-icon.styles.scss';
import { connect } from 'react-redux';
import { selectCartItemsCount} from '../../redux/cart/cart.selectors';
import { toggleCartHidden } from '../../redux/cart/cart.action';

const CartIcon = ({ toggleCartHidden, itemCount }) => (
    <div className='cart-icon' onClick={toggleCartHidden}>
        <ShoppingIcon className='shopping-icon' />
        <span className='item-count'>{itemCount}</span>
    </div>
)

const mapDispatchToProps = dispatch => ({
    toggleCartHidden: () => dispatch(toggleCartHidden())
})

const mapStateToProps = ( state /*{ cart: { cartItems } }*/) => ({
    itemCount: selectCartItemsCount(state) //usando selector para memoizing: para evitar que siempre se ejecute el mapStateToProps cada vez que se actualiza el state.
                //cartItems.reduce((accumulatedQuantity, cartItem) => accumulatedQuantity + cartItem.quantity, 0)
});

export default connect(mapStateToProps, mapDispatchToProps)(CartIcon);